const events = {
  requestStart: new Event('requestStart'),
  requestEnd: new Event('requestEnd'),
};

export const request = (config) => {
  if (config.showLoader) {
    window.dispatchEvent(events.requestStart);
  }

  return config;
};

export const response = {
  success: (response) => {
    if (response.config.showLoader) {
      window.dispatchEvent(events.requestEnd);
    }

    return response;
  },
  error: (error) => {
    if (error.config.showLoader) {
      window.dispatchEvent(events.requestEnd);
    }

    return Promise.reject(error);
  },
};



/** WEBPACK FOOTER **
 ** ./src/helpers/request/interceptors/loader.js
 **/